<template>
  <div>
    <el-row class="container" style="margin-top:15px;" :gutter="20">
      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="6">
       <el-row style="margin-bottom:15px;">
          <el-col :span="16">
            <div class="title">{{ $t('NAVBAR_gestionNoticias') }}</div>
          </el-col>
          <el-col :span="8" class="btn-nuevo">
            <router-link class="btn-nuevo" :to="{ name: 'Alta Noticia'}">
              <el-button type="primary" icon="el-icon-plus" size="small" round>{{ $t('GENERAL_nuevo') }}</el-button>
            </router-link>
          </el-col>
        </el-row>

        <el-row>
          <el-collapse v-model="activeNames" style="margin-bottom: 5px;">
            <el-collapse-item :title="$t('GENERAL_Busqueda_Simple')" name="1">
              <div class="filters"> 
                <div class="filters_item">
                  <div class="label">{{ $t('NOTICIAS_titulo') }}</div>
                  <el-input
                    :placeholder="$t('NOTICIAS_titulo_missing')"
                    size="small"
                    v-model="filtros.titulo"
                    @input="getNoticiasDelayed"
                    clearable
                  />
                </div>
                <div class="filters_item">
                  <div class="label">{{$t('NOTICIAS_estado')}}</div>

                    <el-select clearable class="seleccionador" 
                      v-model="filtros.estado" 
                      size="small" 
                      @change="getNoticiasDelayed"
                      :placeholder="$t('NOTICIAS_seleccionar_estado')"
                    >
                      <el-option :value="1" :label="$t('NOTICIAS_estado_borrador')"></el-option>
                      <el-option :value="2" :label="$t('NOTICIAS_estado_publicado')"></el-option>
                      <el-option :value="3" :label="$t('NOTICIAS_estado_eliminado')"></el-option>
                  </el-select>
                </div>
                <div class="filters_item">
                  <div class="label">{{$t('NOTICIAS_registrado_por')}}</div>
                  <el-input
                    :placeholder="$t('NOTICIAS_registrado_por')"
                    size="small"
                    v-model="filtros.registrado_por"
                    @input="getNoticiasDelayed"
                    clearable
                  />
                </div>
                
                <div class="filters_item">
                  <div class="label">{{$t('GENERAL_desde')}}</div>
                  <el-date-picker
                      class="seleccionador"
                      v-model="filtros.fec_pub_desde"
                      type="date"
                      size="small"
                      format="dd/MM/yyyy"
                      placeholder="dd/MM/yyyy"
                      suffix-icon="el-icon-date"
                      @input="getNoticiasDelayed"
                  />
                  <div class="label">{{$t('GENERAL_hasta')}}</div>
                  <el-date-picker
                    class="seleccionador"
                    v-model="filtros.fec_pub_hasta"
                    type="date"
                    size="small"
                    format="dd/MM/yyyy"
                    placeholder="dd/MM/yyyy"
                    suffix-icon="el-icon-date"
                    @input="getNoticiasDelayed"
                  />
                </div>

              <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de búsqueda --> 
      <el-col class="container_col_2" :span="17">
        <!-- Header resultados de búsqueda -->
        <el-row style="margin-bottom:15px;">
          <el-col :xs="8" :sm="12"  :md="10" :lg="16" :xl="16">
             <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          <el-col :xs="16" :sm="12"  :md="14" :lg="8" :xl="8" >
            <el-pagination 
              class="pagination_container"        
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :total="paginador.nro_pages"
              :page-size="paginador.pageSize"
              @current-change="handlePageChange"
              hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>



        <!-- Noticias -->
        <div>
            <div v-if="loading" v-loading.lock="loading" class="loader"></div>
            <div v-else-if="noticias !== undefined && noticias.length > 0">

            <div class="card_list_item" v-for="noticia in noticias" :key="noticia.Id">
              <GestionNoticiaCard 
              :noticia="noticia" 
              @editar="editNoticia"
              @anular="onAnularNoticia"
              @publicar="onPublicarNoticia"/>

            </div>
            </div>
            <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>           
          </div>       
      </el-col>
    </el-row>
    <!-- Paginador abajo -->
    <el-row style="margin-top:10px; margin-right:20px; text-align: right;">
      <el-col :span="23">
        <el-pagination   
              class="pagination_container"      
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :total="paginador.nro_pages"
              :page-size="paginador.pageSize"
              :pager-count="5"
              @current-change="handlePageChange"
              hide-on-single-page
        ></el-pagination>
      </el-col>
    </el-row>
    <Dialog 
      :visible="id_noticia_a_publicar !== undefined"
      :title="$t('NOTICIA_publicar')"
      :message="publicar_noticia_msg"
      :onClose="onCloseAnularConfirmationPublicar"
    />

    <Dialog 
      :visible="id_noticia_a_anular !== undefined"
      :title="$t('NOTICIA_eliminar')"
      :message="anular_noticia_msg"
      :onClose="onCloseAnularConfirmationAnular"
    />
  </div>
</template>


<script>
import GestionNoticiaCard from "@/components/Cards/gestionNoticiaCard";
import Dialog from "../Dialog";
import { mapState } from "vuex";
import { debuglog } from 'util';
import { loadavg } from 'os';
import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado';
import { showError, showSuccess } from '../Mensaje';


let defaultPaginador = {
  page: 0,
  nro_pages: 1,
  pageSize: 20
};

let defaultFilters = {
    titulo: "",
    // por defecto se buscan las noticias en estado publicadas
    estado: 2,
    registrado_por: "",
    fec_pub_desde: "",
    fec_pub_hasta: "",
};

export default {
  name: "Noticias",
  components: { GestionNoticiaCard, Dialog },
  data() {
    return {
      noticia: undefined,
      noticias: undefined,
      paginador: { ...defaultPaginador },
      filtros: { ...defaultFilters },
      activeNames: ["1"],
      loading: false,
      opened: false,

      //PUBLICAR
      id_noticia_a_publicar: undefined,
      publicar_noticia_msg: "",

      //ANULAR
      id_noticia_a_anular: undefined,
      anular_noticia_msg: "",
    };
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      ultimoFiltroAplicado: state => state.gestionNoticias.filtrosNoticia
    }),
  },

  methods: {
    handlePageChange(page) 
    {
      this.paginador.page = page;
      this.getNoticias();
    },

    getNoticias() 
    {
      // armo el payload
      let payload = { ...this.filtros };
      payload.fec_pub_desde = this.filtros.fec_pub_desde || ''
      payload.fec_pub_hasta = this.filtros.fec_pub_hasta || ''      
      payload.page = this.paginador.page
      payload.pageSize = this.paginador.pageSize

      // No se busca hasta que no se ingresa un filtro
      if (
        this.filtros.titulo == "" &&
        this.filtros.estado == "" &&
        this.filtros.registrado_por == "" &&
        this.filtros.fec_pub_desde == "" &&
        this.filtros.fec_pub_hasta == ""
        )
        return

      // indico que se están buscando las noticias
      this.loading = true;

      // guardo los filtros de noticias
      this.$store.dispatch('gestionNoticias/setFiltrosNoticia', payload)

      // busco las noticias
      this.$store.dispatch("gestionNoticias/getNoticias", payload)
      .then(data => {
        this.noticias = data.Result
        this.paginador.nro_pages = data.TotalPages
      })
      .finally(() => (this.loading = false));
    },

    /*publicarNoticia(id)
    {
      this.loading = true;
      this.$store.dispatch("gestionNoticias/getNoticia", { id: id })
      .then(data => { this.publicar(data); });
    },*/
    publicarNoticia(id)
    {
      this.loading = true;
      this.$store.dispatch("gestionNoticias/publicarNoticia", { id: id })
      .then(result => { 
        if (result != 0)  mostrarMensajeInternacionalizado(
            result.CodigoResultado,
            result.DescripcionResultado
          );
        else showSuccess(this.$t("GENERAL_success"));
      })
      .finally((this.getNoticias()));
    },

    getNoticiasDelayed() 
    {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.getNoticias();
      }, 1000);
    },

    editNoticia(id) 
    {
      this.$router.push({ path: `/gestionNoticias/edicion/${id}`});
    },

    onPublicarNoticia(id, titulo) 
    {
      // armo el mensaje a mostrar
      let mensaje = this.$t('NOTICIA_publicar_mensaje')
      mensaje = mensaje.replace('[titulo]', titulo)
      this.publicar_noticia_msg = mensaje
     
      // guardo la noticia a publicar
      this.id_noticia_a_publicar = id

    },

    onAnularNoticia(id, titulo)
    {
      // armo el mensaje a mostrar
      let mensaje = this.$t('NOTICIA_eliminar_mensaje')
      mensaje = mensaje.replace('[titulo]', titulo)
      this.anular_noticia_msg = mensaje
     
      // guardo la noticia a anular
      this.id_noticia_a_anular = id
    },

    onCloseAnularConfirmationPublicar(confirm) 
    {
      // si confirmó el diálogo, publico la noticia
      if(confirm)
      {
        this.publicarNoticia(this.id_noticia_a_publicar)
      }
      
      // limpio los valores del diálogo
      this.id_noticia_a_publicar = undefined
      this.publicar_noticia_msg = ''
    },

    onCloseAnularConfirmationAnular(confirm) 
    {
      // si confirmó el diálogo, anulo la noticia
      if(confirm)
      {
        this.anularNoticia(this.id_noticia_a_anular)
      }
      
      // limpio los valores del diálogo
      this.id_noticia_a_anular = undefined
      this.anular_noticia_msg = ''
    },

    anularNoticia(id) 
    {
      this.$store.dispatch("gestionNoticias/anularNoticia", { id: id })
      .then(result => {
        if (result.CodigoResultado != 0)  mostrarMensajeInternacionalizado(
            result.CodigoResultado,
            result.DescripcionResultado
          );
        else showSuccess(this.$t("GENERAL_success"));
      })
      .finally(() => (this.getNoticias()));
    },

    cleanFilters() 
    {
      // limpio los filtros
      this.filtros = { ...defaultFilters };
      this.paginador = { ...defaultPaginador };

      // limpio los resultados de noticias
      this.noticias = [];

      // limpio la bandera de noticia creada
      this.id_noticia_creada = undefined;
      this.getNoticias();
    },

    toggleOpen() 
    {
      this.opened = !this.opened      
    }
  },
  
  mounted() 
  {
    //Scroll para Android
    document.body.scrollTop = 0;
    //Scroll para IOS
    document.documentElement.scrollTop = 0;
    
    // verifico si se viene desde la creacion de una noticia. En ese caso se debe mostrar la noticia creada
    if(this.$route.params.idNuevaNoticia)
    {
      this.loading = true;
      this.$store.dispatch('gestionNoticias/getNoticia', {id: this.$route.params.idNuevaNoticia})
      .then((data) => {
        this.filtros.titulo = data.Titulo;
        this.filtros.estado = data.EstadoNoticia.Id;
        this.filtros.registrado_por = data.Usuario.NombreUsuario;
        
        //this.getNoticias();
        this.noticias = [data]
      })
      .finally(() => (this.loading = false));
      
    }
    else
    {
      // verifico si se deben mantener los últimos filtros aplicados
      if (this.$route.params.keepFilter === true)
      {
        this.filtros = { ...this.ultimoFiltroAplicado };
      }

      // busco las noticias
      this.getNoticias();

    }
      
      }

}
</script>

<style>
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
</style>
<style scoped>

.greyLabel {
  color: #6B6B6B;
  font-weight: normal;
}

.blackLabel {
  font-size: 14px;
  color: black;
  text-align: left;
  font-weight: bold;
}

.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}

.tituloNoticia{
  font-size: 14px;
  font-weight: bold;
  text-align: left;
}

.seleccionador {
    width: 100%;
    padding: 0;
}

.btn-nuevo {
  padding-right:0%;
  text-align:right;
}
.el-card {
  height: 100%;
}
.cardBody {
  padding-left: 25px;
}

.container {
  display: flex;
  min-height: 500px !important;
  width:  100% !important;
}

.pagination_container {
  text-align: right;
  padding-right:0px;
}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 1;
    width:100% !important;
  }
  .container_col_2 {
    flex: 1;
    width:100% !important;
    margin-top:20px;
  }
}

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
}
.card_list_item {
  position: relative;
}
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.fec_publicacion {
  grid-column-start: 2;
  grid-row-start: 2;
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}

.info {
  margin-top: 20px;
}

.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}
.el-card__body {
  padding: 20px 40px;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;   
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.soonToExpire {
  font-size: 14px;
  color: #2e2e2e;
  font-weight: bold;
  text-align: left;
  margin-top: 40px;
}
.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.loader {
  margin-top: 25%;
  color: #999;
}
</style>


